<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <!-- <el-breadcrumb-item :to="{ path: '/home', query: { tab: 'combination' } }">
                    组合投资
                </el-breadcrumb-item> -->
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="assets-detail">
            <div class="assets-title">持仓详情</div>
            <div class="assets-row">
                <div class="title-line"></div>
                <span class="title-content">资产分布</span>
            </div>
            <div class="assets-info">
                <div class="assets-left">
                    <div ref="assets-chart" class="assets-chart"></div>
                    <div class="assets-type">
                        <div v-for="(item, index) in ratioList" :key="index" class="type-item">
                            <div class="icon" :style="{ background: colorList[index] }"></div>
                            <span class="text">{{ $cache.getDict("110144", item.fundtype) }}</span>
                            <span class="rate">{{ $util.fmtNum(item.ratio * 100) }}%</span>
                        </div>
                    </div>
                </div>
                <div class="assets-right">
                    <div v-for="(item, index) in ratioList" :key="index" class="combo-item">
                        <div class="combo-title" v-on:click="comboClicked(index)">
                            <div class="combo-box">
                                <div
                                    class="type-point"
                                    :style="{ background: colorList[index] }"
                                ></div>
                                <span>{{ $cache.getDict("110144", item.fundtype) }}</span>
                            </div>
                            <div class="combo-box">
                                <div class="rate-text" :style="{ color: colorList[index] }">
                                    {{ $util.fmtNum(item.ratio * 100) }}%
                                </div>
                                <i
                                    class="arrow"
                                    :class="
                                        activeIndex == index
                                            ? 'el-icon-caret-top'
                                            : 'el-icon-caret-bottom'
                                    "
                                ></i>
                            </div>
                        </div>
                        <template v-if="activeIndex == index">
                            <div v-for="(fund, idx) in item.fundArr" :key="idx" class="fund-item">
                                <div class="fund-info">
                                    <span class="fund-name">{{ fund.fundname }}</span>
                                    <span class="nav-date">{{ $util.fmtDate(fund.navdate) }}</span>
                                </div>
                                <div class="fund-rate">{{ $util.fmtNum(fund.ratio * 100) }}%</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="assets-row">
                <div class="title-line"></div>
                <span class="title-content">最近调仓</span>
                <el-select v-model="selectVersion" style="margin-left: auto">
                    <el-option
                        v-for="item in adjustList"
                        :key="item.strategyversion"
                        :label="$util.fmtDate(item.effectdate)"
                        :value="item.strategyversion"
                    />
                </el-select>
            </div>
            <!-- <div class="transfer-item">
                本期调仓说明：天弘互联网和广发小盘持有半导体、芯片的仓位较重，受中美贸易战和华为供应链的影响，短期会有调整压力，增加医疗创新占比。
            </div> -->
            <div v-for="(item, index) in adjustInfo" :key="index" class="transfer-item">
                <div class="transfer-left">
                    <span
                        class="business-type"
                        :class="item.lastweight < item.weight ? 'buy' : 'sell'"
                    >
                        {{ item.lastweight < item.weight ? "买" : "卖" }}
                    </span>
                    <span class="fund-name">{{ item.fundname }}</span>
                </div>
                <div class="transfer-right">
                    <span>{{ $util.fmtNum(item.lastweight) }}%</span>
                    <img src="@/assets/img/transfer-ic.png" alt="" />
                    <span class="to">{{ $util.fmtNum(item.weight) }}%</span>
                </div>
            </div>
            <div style="height: 20px"></div>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import echarts from "echarts/index.common";

export default {
    name: "AssetsDetail",
    components: {},
    mixins: [mixin],
    data() {
        return {
            strategycode: "", // 组合代码
            ratioList: [], // 基金占比列表
            adjustList: [], // 调仓记录列表
            selectVersion: "", // 所选调仓版本号
            adjustInfo: [], // 调仓情况
            colorList: ["#2789FF", "#42CCCC", "#F18F57", "#D787FF", "#755FFF", "#8CE860"], // 色值列表
            lineArt: null, // 环形图
            activeIndex: -1 // 选中类型占比下标
        };
    },
    watch: {
        selectVersion() {
            this.qryStrategyAdjustDetail();
        }
    },
    beforeDestroy() {
        if (this.lineArt) {
            this.lineArt.clear();
        }
    },
    mounted() {
        this.strategycode = this.$route.query.strategycode;
        this.qryStrategyFundRatio();
        this.qryStrategyAdjust();
    },
    methods: {
        // 查询基金占比情况
        async qryStrategyFundRatio() {
            const res = await fundApi.qryStrategyFundRatio({
                strategycode: this.strategycode
            });
            if (res.data) {
                const list = this.$util.getCodeOnly(res.data, {
                    code: "fundtype",
                    data: ["ratio"]
                });
                this.ratioList = list;
                this.initChart();
            }
        },
        // 查询组合调仓记录
        async qryStrategyAdjust() {
            const res = await fundApi.qryStrategyAdjust({
                strategycode: this.strategycode
            });
            if (res.data) {
                this.adjustList = res.data || [];
                if (this.adjustList.length > 0) {
                    this.selectVersion = this.adjustList[0].strategyversion;
                }
            }
        },
        // 查询每期调仓的基金情况
        async qryStrategyAdjustDetail() {
            const res = await fundApi.qryStrategyAdjustDetail({
                strategycode: this.strategycode,
                strategyversion: this.selectVersion
            });
            if (res.data) {
                this.adjustInfo = res.data;
            }
        },
        // 开始绘制图表
        initChart() {
            let series = [];
            this.ratioList.forEach((item) => {
                series.push({
                    value: item.ratio,
                    name: this.$cache.getDict("110144", item.fundtype)
                });
            });
            this.lineArt = echarts.init(this.$refs["assets-chart"]);
            let _x = {
                color: this.colorList,
                grid: {
                    left: "2%",
                    right: "4%",
                    bottom: "3%",
                    top: "20px",
                    containLabel: true
                },
                series: [
                    {
                        type: "pie",
                        silent: true,
                        label: {
                            show: false
                        },
                        data: series,
                        radius: ["40%", "70%"]
                    }
                ]
            };
            // 把配置和数据放这里
            this.lineArt.setOption(_x);
            this.resizeChart();
        },
        // 图表变化重绘
        resizeChart() {
            const _this = this;
            window.addEventListener("resize", () => {
                if (_this.lineArt) {
                    _this.lineArt.resize();
                }
            });
        },
        // 点击组合名
        comboClicked(index) {
            if (this.activeIndex == index) {
                this.activeIndex = -1;
            } else {
                this.activeIndex = index;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-detail {
    margin-top: 10px;
    margin-bottom: 20px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    width: 1200px;
    .assets-title {
        padding: 20px 0 25px 16px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        border-bottom: 1px solid #f1f1f1;
    }
    .assets-info {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .assets-left {
            display: flex;
            .assets-chart {
                width: 320px;
                height: 320px;
            }
            .assets-type {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 320px;
                gap: 20px;
                .type-item {
                    display: flex;
                    align-items: center;
                    .icon {
                        width: 18px;
                        height: 18px;
                        border-radius: 2px;
                    }
                    .text {
                        margin-left: 5px;
                        font-size: 16px;
                        color: #999999;
                    }
                    .rate {
                        margin-left: 25px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #333333;
                    }
                }
            }
        }
        .assets-right {
            margin: 30px 0;
            .combo-item {
                width: 580px;
                display: flex;
                flex-direction: column;
                margin-bottom: 6px;
                .combo-title {
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 17px;
                    background: #f9f9f9;
                    box-sizing: border-box;
                    border: 1px solid #f1f1f1;
                    cursor: pointer;
                    .combo-box {
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-weight: 500;
                        color: #333333;
                        .type-point {
                            width: 8px;
                            height: 8px;
                            border-radius: 4px;
                            background: #ff7d00;
                            margin-right: 10px;
                        }
                        .rate-text {
                            font-size: 18px;
                            font-weight: bold;
                            color: #ff7d00;
                            margin-right: 10px;
                        }
                        .arrow {
                            color: #999999;
                        }
                    }
                }
                .fund-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 19px 40px 19px 15px;
                    border: 1px solid #f1f1f1;
                    border-top: none;
                    .fund-info {
                        display: flex;
                        flex-direction: column;
                        .fund-name {
                            font-size: 16px;
                            font-weight: bold;
                            color: #333333;
                            margin-bottom: 6px;
                            max-height: 300px;
                        }
                        .nav-date {
                            font-size: 14px;
                            font-weight: bold;
                            color: #999999;
                        }
                    }
                    .fund-rate {
                        font-size: 18px;
                        font-weight: bold;
                        color: #333333;
                    }
                }
            }
        }
    }
    .assets-row {
        margin: 20px 20px 0 20px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        height: 60px;
        border-radius: 2px 2px 0px 0px;
        background: #f9f9f9;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
    }
    .transfer-item {
        border: 1px solid #f1f1f1;
        border-top: none;
        font-size: 14px;
        color: #666666;
        padding: 16px;
        margin: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .transfer-left {
            display: flex;
            align-items: center;
            .business-type {
                width: 24px;
                height: 24px;
                border-radius: 4px;
                text-align: center;
                line-height: 24px;
                font-size: 14px;
            }
            .buy {
                background: #ffecec;
                color: var(--color-primary);
            }
            .sell {
                background: #edf7ff;
                color: #1890ff;
            }
            .fund-name {
                margin-left: 11px;
                font-size: 16px;
                font-weight: 500;
                color: #333333;
            }
        }
        .transfer-right {
            display: flex;
            align-items: center;
            gap: 20px;
            font-size: 18px;
            font-weight: bold;
            color: #666666;
            .to {
                color: #333333;
                min-width: 70px;
                text-align: right;
            }
        }
    }
}
</style>
